module.exports = __webpack_public_path__ + "fonts/poppins-semibolditalic-webfont.c06f681f.woff2";